// extracted by mini-css-extract-plugin
export default {"logo":"Logotype_logo__RrkMS"};